//ALL REACT
import * as React from 'react';
//MUI COMPONENTS
import { Paper, TextField, Box, MenuItem, InputAdornment, IconButton, Button, Tooltip, Typography } from '@mui/material';
//MUI ICONS
import { Clear, Download, Search, Queue } from '@mui/icons-material';
//API CONTOLLER
import ApiController from '../../controllers/api';
//CUSTOM COMPONENTS
import CustomBackdrop from '../CustomBackdrop';
//OTHERS
// COMPONENTS DATAGRID
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import Swal from 'sweetalert2';

import { usePermissions } from '../../hooks/usePermission';

import CustomModal from '../CustomModal';
import AsignSafeGaurds from '../asignSafeGuards';

export default function CatalogAsignSafe() {
  const [filterValue, setFilterValue] = React.useState('');
  const [getValues, setGetValues] = React.useState([]);
  const [openBackdrop, setOpenBackdrop] = React.useState(true);
  const [openModal, setOpenModal] = React.useState(null);
  const { isAuthenticated, canCreate, canDownload, canViewAsignSafe } = usePermissions();
  
  const apiInstance = React.useMemo(() => new ApiController(process.env.REACT_APP_API_URL), []);
  const downloadSafeGuard = async (safeguardId, fileName = null) => await apiInstance.downloadPDFById(`/safe-guard/download/?SAFE_GUARD=${safeguardId}`, fileName);
  const apiRef = useGridApiRef();
 const handleDownload = async (safeguard, fileName) => {
      const result = await Swal.fire({
        title: "VALER DE RESGUARDO",
        text: "¿ESTAS SEGURO QUE DESEAS DESCARGAR EL VALE DE RESGUARDO?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "SI, DESCARGAR",
        confirmButtonColor: "#09abfb",
        allowOutsideClick: false,
        allowEscapeKey: false
      });
      if (result.isConfirmed) {
        downloadSafeGuard(safeguard, fileName);
      }
 }
  const getData = async () => {
  const res = await apiInstance.get('/safe-guard');
    if (res.success) {
       setGetValues(res.data);
    }else{
        Swal.fire({
            title: '¡ERROR! ❌',
            icon: 'error',
            text: 'NO SE PUDIERÓN CARGAR LOS DATOS',
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor:'#ef7474',
            confirmButtonText: 'CONFIRMAR',
            padding: '0 0 20px'
        });
    }
    setOpenBackdrop(false);
  }
  React.useEffect(() => {
    if(!isAuthenticated || !canViewAsignSafe)return;
    getData();
  }, []);

  const handleOpen = (modalType) => setOpenModal(modalType);
  const handleClose = () => setOpenModal(null);
  const columns = [
    { field: 'FOLIO', headerName: 'NO. FOLIO', width: 100, type: 'number'},
     { field: 'FECHA', headerName: 'FECHA GENERACIÓN', width: 168 , type: 'date',
      valueGetter: (value, row) => {
         if (!value) return null;
          const date = new Date(value);
          return new Date(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate()
          );
        },
      valueFormatter: (value) => {
        if (!value) return "N/A";
        return new Date(value).toLocaleDateString("es-MX", {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
      }
    },
    { field: 'AREA', headerName: 'ÁREA DEL VALE', width: 250, type: 'text'},
     {
          field: 'ACCIONES',
          headerName: 'ACCIONES',
          sortable: false,
          flex: 1,
          minWidth: 50,
          disableExport: true,
          renderCell: (params) => (
            <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: "break-word", width: "fit-content" }}>
              {canDownload && (
              <Tooltip title="DESCARGAR VALE DE RESGUARDO" placement="bottom-start">
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={() => handleDownload(params.row.ID, params.row.FOLIO)}
                sx={{
                backgroundColor: "#0daafa",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#0da1ecff"
                }
              }}
                >
                  <Download />
                </Button>
              </Tooltip>
              )}
            </div>
          )
        }
  ];
  const filterableColumns = columns.filter(col => col.field !== 'ACCIONES');
  const [filterColumn, setFilterColumn] = React.useState(filterableColumns[0].field);
  const currentColumnType = columns.find(col => col.field === filterColumn)?.type || 'text';
  const filteredRows = React.useMemo(() => {
    if (!filterValue) return getValues || [];
    return (getValues || []).filter(row => {
      const value = row[filterColumn];
      if (value === null || value === undefined) return false;
      return value.toString().toLowerCase().includes(filterValue.toLowerCase());
    });
  }, [getValues, filterColumn, filterValue]);

  return (
    <>
        <Paper sx={{ background: "transparent", border: "none", boxShadow:"none", height: "auto", width: '90%', minWidth: 300, maxWidth: 620, p: 2, margin: "auto", marginTop: "100px" }}>
          <Typography variant="h6" fontWeight={500}>ASIGNACIÓN DE <b>RESGUARDOS</b></Typography>
        </Paper>
      <Paper sx={{ height: "auto", width: '90%', minWidth: 300, maxWidth: 620  , p: 2, margin: "auto", marginBottom: "50px" }}>
        <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap'}}>
          <TextField
            select
            label="BUSCAR POR"
            value={filterColumn}
            onChange={e => setFilterColumn(e.target.value)}
            size="small"
          >
            {filterableColumns.map(col => (
              <MenuItem key={col.field} value={col.field}>{col.headerName}</MenuItem>
            ))}
          </TextField>
          <TextField
            label="BUSCAR"
            variant="outlined"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            size="small"
            type={currentColumnType}
            autoComplete='false'
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {filterValue && (
                    <IconButton
                      aria-label="clear search"
                      onClick={() => setFilterValue("")}
                      edge="end"
                    >
                      <Clear />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
          />
          {canCreate && (
          <Tooltip title="AGREGAR NUEVO" placement="bottom-start">
          <Button variant="contained" size="small" color="success" onClick={() => handleOpen("safeGuards")}>
            <Queue />
          </Button>
          </Tooltip>
          )}
        </Box>
        <DataGrid
          apiRef={apiRef}//REFERENCIA PARA EXPORTAR
          disableColumnMenu// DESACTIVA EL MENU DE COLUMNA
          disableRowSelectionOnClick// EVITA QUE SELECCIONE LA FILA AL DAR CLICK EN ELLA
          rows={filteredRows}// FILAS A MOSTRAR
          columns={columns}// COLUMNAS A MOSTRAR
          getRowHeight={() => 50}// ALTO DE FILA AUTOMATICO
          getRowId={(row) => row.ID}// LLAVE UNICA DE CADA FILA
          initialState={{ pagination: { paginationModel: { page: 0, pageSize: 10 } } }}// ESTADO INICIAL DE LA PAGINACION
          pageSizeOptions={[5, 10]}// OPCIONES DE PAGINACION
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}// IDIOMA A ESPAÑOL
        />
    </Paper>
      <CustomBackdrop open={openBackdrop}/>
      <CustomModal open={openModal === 'safeGuards'} onClose={handleClose} Component={AsignSafeGaurds} asignData={[]} refreshData={getData}/>
    </>
  );
}